import script from "./GameStatusOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./GameStatusOverlay.vue?vue&type=script&setup=true&lang=js"

import "./GameStatusOverlay.vue?vue&type=style&index=0&id=029e3532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-029e3532"]])

export default __exports__